import { ReactNode, useEffect, useState } from 'react'

import { Tabs, Tab, TabPanels, TabPanel } from 'app/common/ui/PlainTabs'

type Props = {
  tabIndex: 1 | 2
  daysContent: ReactNode
  monthsContent: ReactNode
}

const DateMonthSwitcher = ({ tabIndex, daysContent, monthsContent }: Props) => {
  const [activeTabIndex, setActiveTabIndex] = useState<number>(tabIndex)

  useEffect(() => {
    setActiveTabIndex(tabIndex)
  }, [tabIndex])

  return (
    <>
      <Tabs value={activeTabIndex} onChange={setActiveTabIndex} skipUpperSpace>
        <Tab index={1}>{'День'}</Tab>
        <Tab index={2}>{'Месяц'}</Tab>
      </Tabs>
      <TabPanels value={activeTabIndex} unmountHidden>
        <TabPanel index={1}>{daysContent}</TabPanel>
        <TabPanel index={2}>{monthsContent}</TabPanel>
      </TabPanels>
    </>
  )
}

export default DateMonthSwitcher
